import type { CompanyContentBoostType } from "@/modules/companies/client/api/contentBoostTypes"
import type { FunctionComponent } from "react"

import { AI_COVER_LETTER, AI_COVER_LETTER_VARIANTS } from "@/modules/aiCoverLetter/constants/flags"
import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { PaginationWrapper } from "@/modules/jobAds/client/components/PaginationWrapper/PaginationWrapper"
import { ResultsWrapper } from "@/modules/jobAds/client/components/ResultsWrapper/ResultsWrapper"
import {
  JOB_ADS_CONTENT_BOOST,
  JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE,
  JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE_VARIANTS,
} from "@/modules/jobAds/client/constants/flags"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { usePrefilteredJobSearch } from "@/modules/jobSearchPrefiltered/hooks/usePrefilteredJobSearch"
import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"
import { useFlag } from "@/modules/unleash/hooks/useFlag"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

export const JobAdsResults: FunctionComponent = () => {
  const isJobAdsContentBoostActive = useFlag(JOB_ADS_CONTENT_BOOST)
  const isAICoverLetterPushVisible = useFlag(AI_COVER_LETTER, AI_COVER_LETTER_VARIANTS.ENABLED)
  const isSavedSearchOnMobileVisible = useFlag(
    JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE,
    JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE_VARIANTS.ENABLED
  )
  const { dataJobAds, isErrorJobAds } = useJobAdsFromAlgolia<CompanyContentBoostType>()
  const { dataCareerCenter } = useCareerCenterFetch()
  const { dataCurrentUser } = useCurrentUserFetch()
  const { savedSearch } = usePageContext()

  const hasUserSavedSearches = !!savedSearch
  const hasCcRssFeed = Boolean(dataCareerCenter?.careerCenterConf?.modules?.hasRssFeed)
  const isUserSuperAdmin = Boolean(dataCurrentUser?.attributes?.isCcSuperAdmin)
  const contentBoost = dataJobAds && !!dataJobAds.algoliaCustomData?.length ? dataJobAds?.algoliaCustomData[0] : null
  const isContentBoostVisible = isJobAdsContentBoostActive && !!contentBoost
  const isPrivateOfferButtonVisible = dataCareerCenter?.careerCenterConf?.postOfferFromFrontOffice || false
  const isRssFeedVisible = isUserSuperAdmin && hasCcRssFeed
  const isPrefilteredJobSearchPage = usePrefilteredJobSearch()
  const isSavedSearchVisible = !isErrorJobAds && dataCurrentUser?.isLogged && hasUserSavedSearches

  const hasAside =
    isSavedSearchVisible ||
    isPrefilteredJobSearchPage ||
    isRssFeedVisible ||
    isPrivateOfferButtonVisible ||
    isContentBoostVisible ||
    isAICoverLetterPushVisible

  return (
    <LayoutChild
      {...(hasAside
        ? {
            from: 1,
            to: 8,
          }
        : {
            variant: "large",
          })}
    >
      <ResultsWrapper isSavedSearchOnMobileVisible={isSavedSearchOnMobileVisible} />
      <PaginationWrapper />
    </LayoutChild>
  )
}
